import styled from "styled-components";
import { Button } from "../../../../UI";

const StyledTag = styled.span`
  position: absolute;
  right: -5px;
  top: -7px;
  font-size: 9px !important;
  border-radius: 100px;
  background: var(--fontColor);
  width: 14px;
  height: 14px;
  color: var(--selectionFontColor);
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const ActionButton = ({
  onClick,
  count,
  showCount = false,
  Icon,
  color,
  styles,
  isActive = false,
  children,
  disabled = false,
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      // color={(isActive || count > 0) && color ? color : "#4b4b4b"}
      style={{
        borderColor: isActive || count > 0 ? color : "",
        padding: "0px 8px",
        position: "relative",
        ...styles,
      }}
      disabled={!(typeof count !== "undefined" ? count > 0 : true) || disabled}
      position="relative"
      selected={count > 0}
      isNew
      {...props}
    >
      {Icon && (
        <Icon
          // fill={isActive || count > 0 ? color : "#4b4b4b"}
          width="16"
          height="16"
        />
      )}
      {children}
      {count > 0 && <StyledTag>{count}</StyledTag>}
    </Button>
  );
};

export default ActionButton;
